import { actionStrings } from "./tableSortingUtils";

export const synchronizeLocalFilters = (
  data,
  projectId,
  taskType,
  setSelectedFilters,
  setLocalSyncToggle,
  dispatch,
) => {
  const settingsStr = localStorage.getItem("ws-project-settings");
  const foundSettings = JSON.parse(settingsStr || "[]");
  if (foundSettings && foundSettings.length > 0) {
    const foundProject = foundSettings.find(
      (project) => project?.projectId === projectId,
    );

    if (!foundProject) return;
    const selectedFilters = foundProject[taskType]?.selectedFilters || [];
    const newSelectedFilters = {};

    Object.entries(selectedFilters).forEach(([uuid, filterObj]) => {
      const { value } = filterObj;

      if (typeof value !== "string") {
        newSelectedFilters[uuid] = filterObj;
        return;
      }

      const existsInData = data.some((project) =>
        project.metadata.some((metaField) => {
          const metaFieldValue = metaField.value;

          if (
            typeof metaFieldValue === "string" ||
            Array.isArray(metaFieldValue)
          ) {
            return metaFieldValue.includes(value);
          }

          return false;
        }),
      );

      if (existsInData || actionStrings.includes(value)) {
        newSelectedFilters[uuid] = filterObj;
      }
    });
    dispatch(setSelectedFilters(newSelectedFilters));
    dispatch(setLocalSyncToggle(false));
  }
};
